export const MOBILE_POPUP_FADE_TRANSITION_LENGTH = 150
export const MOBILE_POPUP_SLIDE_IN_TRANSITION_LENGTH = 150
export const MOBILE_POPUP_SLIDE_OUT_TRANSITION_LENGTH = 100
